import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../material.module';
import { QueriesDialogComponent } from './queries-dialog/queries-dialog.component';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    PipesModule,
    SharedModule,
  ],
  declarations: [
    QueriesDialogComponent,
  ],
  exports: [
    QueriesDialogComponent,
  ],
})
export class QueriesModule { }
